<template>
  <div id="admin_action_logs">
    <Navbar current="Logs de Admin" />
    <Sidebar />
    <Container col="col-12">
      <Header
        title="Logs de Admin"
        subtitle="Auditoria de ações tomadas por administradores"
        :iconClass="'fa-solid fa-clipboard-list text-primary'"
      />

      <AdminActionLogsList />
    </Container>
  </div>
</template>

<script>
export default {
  name: "AdminActionLogs",
};
</script>
